const PrintIcon = ({ color = "rgb(var(--color-brand))" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.0415 5.83366H13.9582V4.16699C13.9582 2.50033 13.3332 1.66699 11.4582 1.66699H8.5415C6.6665 1.66699 6.0415 2.50033 6.0415 4.16699V5.83366Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3332 12.5V15.8333C13.3332 17.5 12.4998 18.3333 10.8332 18.3333H9.1665C7.49984 18.3333 6.6665 17.5 6.6665 15.8333V12.5H13.3332Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 8.33301V12.4997C17.5 14.1663 16.6667 14.9997 15 14.9997H13.3333V12.4997H6.66667V14.9997H5C3.33333 14.9997 2.5 14.1663 2.5 12.4997V8.33301C2.5 6.66634 3.33333 5.83301 5 5.83301H15C16.6667 5.83301 17.5 6.66634 17.5 8.33301Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1668 12.5H13.1585H5.8335"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.8335 9.16699H8.3335"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PrintIcon;
